import { useNuxtApp } from "#app";

// 新增收藏
export function insertUserCollect(data) {
  return useNuxtApp().$customFetch('/mallSite/userCollect/insertUserCollect?mall=1', {
    method: "POST",
    body: data,
  })
}

// 获取收藏夹列表
export function queryCollectionList(data) {
  return useNuxtApp().$customFetch('/mallSite/userCollect/queryUserCollectByUser?mall=1', {
    method: "POST",
    body: data,
  })
}

// 删除收藏
export function cancelUserCollect(data) {
  return useNuxtApp().$customFetch('/mallSite/userCollect/cancelUserCollect?mall=1', {
    method: "POST",
    body: data,
  })
}

// 是否收藏
export function hasCollection(data) {
  return useNuxtApp().$customFetch('/mallSite/userCollect/hasCollect?mall=1&uncheck401=1', {
    method: "POST",
    body: data,
  })
}
